'use client';

import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';

import { MobileLayout } from '@ui/components/features/layout/mobileLayout/mobileLayout';
import { useBackNavigation } from '@website/hooks/useBackNavigation';

interface PublicPageMobileLayoutProps {
  title: string;
  /**
   * URL to navigate to when there is no browser history to go back to
   * (e.g. the page was opened via a direct deep link or shared URL).
   */
  fallbackHref: string;
  children: ReactNode;
}

/**
 * Client wrapper around MobileLayout for public informational pages
 * (FAQ, Privacy Policy, Terms & Conditions).
 *
 * The back button uses router.back() so unauthenticated visitors are returned
 * to wherever they came from, instead of being sent to /settings (a protected
 * route that would redirect them to the sign-in page).
 */
export default function PublicPageMobileLayout({ title, fallbackHref, children }: PublicPageMobileLayoutProps) {
  const t = useTranslations('Common');

  const handleBack = useBackNavigation(fallbackHref);

  return (
    <MobileLayout title={title} onBack={handleBack} backLabel={t('goBack')}>
      {children}
    </MobileLayout>
  );
}
